import React, { useEffect, useState } from "react";

// Components
import SectionTitle from "../SectionTitle";
import OrderChart from "./components/OrderChart";
import RangeFilter from "../../../../../common/components/RangeFilter";

// Order Status static data
const orderStatusData = [
    {
        id: "completed",
        label: "Completed",
        value: 0,
        color: "#00A900",
    },
    {
        id: "processing",
        label: "Processing",
        value: 0,
        color: "#1495FF",
    },
    {
        id: "on_hold",
        label: "On Hold",
        value: 0,
        color: "#555DFF",
    },
    {
        id: "pending",
        label: "Pending",
        value: 0,
        color: "#FFB310",
    },
    {
        id: "refunded",
        label: "Refunded",
        value: 0,
        color: "#FF3A52",
    },
    {
        id: "cancelled",
        label: "Cancelled",
        value: 0,
        color: "#FF4E7B",
    },
    // {
    //     id: "failed",
    //     label: "Failed",
    //     value: 0,
    //     color: "#FF4E7B",
    // },
];

const OrderStatus = () => {
    const [range, setRange] = useState("this-month");
    const [customRange, setCustomRange] = useState({
        from: "",
        to: "",
    });
    const [orderStatus, setOrderStatus] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [filterLabel, setFilterLabel] = useState("This Month");

    const handleRange = (value) => {
        setRange(value);
        setCustomRange({ from: "", to: "" });
    };

    const handleCustomRange = (key, value) => {
        setRange(null);
        setCustomRange({ ...customRange, [key]: value });
    };

    const fetchOrderStatus = (url) => {
        fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "X-WP-Nonce": EASYCOMMERCE.nonce,
            },
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success && data.data?.orders) {
                    const { orders } = data.data;
                    const updatedStatus = orderStatusData.map((item) => ({
                        ...item,
                        value: orders[item.id],
                    }));
                    setOrderStatus(updatedStatus);
                }
                setIsLoading(false);
            });
    };
    useEffect(() => {
        let url = `${EASYCOMMERCE.rest_base}/dashboard/order_statuses`;
        if (range && !customRange.from && !customRange.to) {
            url += `?range=${range}`;
        } else if (!range && customRange.from && customRange.to) {
            const queryString = new URLSearchParams({
                from: customRange.from,
                to: customRange.to,
            }).toString();
            url += `?${queryString}`;
        }
        fetchOrderStatus(url);
    }, [range, customRange]);
    

    return (
        <>
            <div className="flex items-center justify-between mb-5 pr-6 border-b border-ec-table-stock">
                <SectionTitle title="Order Status"/>

                {!isLoading && (
                    <RangeFilter
                        range={range}
                        customRange={customRange}
                        filterLabel={filterLabel}
                        handleRange={handleRange}
                        handleCustomRange={handleCustomRange}
                        handleFilterLabel={(str) => setFilterLabel(str)}
                    />
                )}
            </div>

            <OrderChart isLoading={isLoading} orderStatus={orderStatus} />
        </>
    );
};

export default OrderStatus;
